export const LOGIN = 'login';
export const LOGIN_SUCCESS = 'login_success';
export const LOGOUT = 'logout';
